var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8334 19.0449H13.09L19.745 11.4961C20.0562 11.1426 20.2059 10.6867 20.1612 10.2289C20.1165 9.7711 19.8811 9.3488 19.5067 9.05492C19.1323 8.76104 18.6496 8.61966 18.1648 8.66187C17.6801 8.70408 17.2329 8.92643 16.9217 9.28L7.75504 19.6682C7.69337 19.7508 7.63822 19.8376 7.59004 19.9279C7.59004 20.0144 7.59004 20.0664 7.46171 20.1529C7.37861 20.3514 7.3351 20.5628 7.33337 20.7762C7.3351 20.9897 7.37861 21.201 7.46171 21.3995C7.46171 21.4861 7.46171 21.538 7.59004 21.6246C7.63822 21.7149 7.69337 21.8017 7.75504 21.8843L16.9217 32.2724C17.0941 32.4679 17.3099 32.6251 17.5539 32.7328C17.7979 32.8405 18.064 32.8961 18.3334 32.8957C18.7617 32.8965 19.1769 32.7556 19.5067 32.4975C19.6923 32.3522 19.8458 32.1737 19.9583 31.9722C20.0708 31.7708 20.1401 31.5504 20.1622 31.3236C20.1843 31.0968 20.1589 30.8682 20.0873 30.6507C20.0157 30.4333 19.8994 30.2313 19.745 30.0563L13.09 22.5076H34.8334C35.3196 22.5076 35.7859 22.3252 36.1297 22.0005C36.4736 21.6758 36.6667 21.2354 36.6667 20.7762C36.6667 20.317 36.4736 19.8767 36.1297 19.552C35.7859 19.2273 35.3196 19.0449 34.8334 19.0449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.a2ddb31b7165b72a4cf9df2b5cceda1c.svg";
export { ForwardRef as ReactComponent };